import React, { Fragment } from "react";
import {
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import PropTypes from "prop-types";
import {
  KeyboardDatePicker,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";
import { InputElementSize, InputElementType } from "../types/enums";

const InputElement = ({ item }) => {
  const {
    id,
    label,
    type,
    hidden,
    disabled,
    state,
    setState,
    size,
    min,
    step,
    rows,
    options,
    multiple,
    component,
  } = item;

  const xs = size === InputElementSize.S ? 6 : 12;
  const sm =
    size === InputElementSize.S ? 3 : size === InputElementSize.L ? 12 : 6;

  return (
    <Fragment>
      {!hidden && (
        <Grid key={id} item xs={xs} sm={sm}>
          {type === InputElementType.COMPONENT && component}

          {type === InputElementType.DATE && (
            <KeyboardDatePicker
              clearable
              mask="__-__-____"
              id={id}
              name={id}
              label={label}
              value={state}
              disabled={disabled}
              format={"L"}
              onChange={setState ? (m) => setState(m) : null}
              fullWidth
            />
          )}

          {type === InputElementType.DATE_TIME && (
            <KeyboardDateTimePicker
              clearable
              mask="__-__-____ __:__"
              id={id}
              name={id}
              label={label}
              value={state}
              disabled={disabled}
              format={"L LT"}
              onChange={setState ? (m) => setState(m) : null}
              fullWidth
              ampm={false}
            />
          )}

          {type === InputElementType.NUMBER && (
            <TextField
              type="number"
              id={id}
              name={id}
              label={label}
              value={state}
              disabled={disabled}
              onChange={setState ? (e) => setState(e.target.value) : null}
              fullWidth
              inputProps={{
                ...(min !== undefined && { min: min }),
                ...(step !== undefined && { step: step }),
              }}
            />
          )}

          {type === InputElementType.CHECKBOX && (
            <FormControlLabel
              control={
                <Checkbox
                  id={id}
                  name={id}
                  checked={state}
                  disabled={disabled}
                  onChange={setState ? (e) => setState(e.target.checked) : null}
                />
              }
              label={label}
            />
          )}

          {type === InputElementType.TEXT && (
            <TextField
              id={id}
              name={id}
              label={label}
              value={state}
              disabled={disabled}
              onChange={setState ? (e) => setState(e.target.value) : null}
              multiline={rows > 0}
              rows={rows}
              fullWidth
            />
          )}

          {type === InputElementType.SELECT && (
            <Fragment>
              <InputLabel htmlFor={id}>{label}</InputLabel>
              <Select
                id={id}
                name={id}
                multiple={multiple}
                value={state}
                disabled={disabled}
                onChange={setState ? (e) => setState(e.target.value) : null}
                fullWidth
              >
                {options.map((o) => (
                  <MenuItem
                    key={o.id}
                    value={o.id}
                    style={{
                      fontWeight: (
                        multiple ? state.indexOf(o.id) !== -1 : state !== o.id
                      )
                        ? "normal"
                        : "500",
                    }}
                  >
                    {o.label}
                  </MenuItem>
                ))}
              </Select>
            </Fragment>
          )}

          {item.caption && (
            <Typography variant={item.caption.link ? "button" : "caption"}>
              {item.caption.link && (
                <a href={item.caption.link} target="_blank" rel="noreferrer">
                  {item.caption.text}
                </a>
              )}
              {!item.caption.link && item.caption.text}
            </Typography>
          )}
        </Grid>
      )}
    </Fragment>
  );
};

InputElement.propTypes = {
  item: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      hidden: PropTypes.bool,
      disabled: PropTypes.bool,
      label: PropTypes.string.isRequired,
      state: PropTypes.any.isRequired,
      setState: PropTypes.func,
      size: PropTypes.oneOf(Object.values(InputElementSize)),
      min: PropTypes.number,
      step: PropTypes.number,
      rows: PropTypes.number,
      multiple: PropTypes.bool,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
        }),
      ),
      caption: PropTypes.shape({
        text: PropTypes.string.isRequired,
        link: PropTypes.string,
      }),
    }),
    PropTypes.shape({
      type: "component",
      component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    }),
  ]).isRequired,
};

export default InputElement;



// WEBPACK FOOTER //
// ./src/components/InputElement.js